import Vue from 'vue';
import VueCookie from 'vue-cookies';
Vue.use(VueCookie);
